import { Component } from '@angular/core';

interface ArticleFeature {
    text: string;
}

interface ArticleTag {
    label: string;
}

interface GalleryImage {
    image: string;
    alt: string;
}

@Component({
    selector: 'app-news-single-redesign',
    templateUrl: './news-single-redesign.component.html',
    styleUrls: ['./news-single-redesign.component.scss']
})
export class NewsSingleRedesignComponent {

    /* ==========================================
        Hero
    ========================================== */

    heroImage = '/assets/img/redesign/news/news.png';

    heroAlt = 'Article Image';

    /* ==========================================
        Article Meta
    ========================================== */

    publishDate = '02 Apr 2024';

    author = 'Camunda';

    comments = 12;

    readingTime = '3 min Read';

    /* ==========================================
        Title
    ========================================== */

    title = 'The whimsically named Egg Canvas brainchild';

    /* ==========================================
        Introduction
    ========================================== */

    introduction: string[] = [

        'He whimsically named Egg Canvas is the brainchild of Erica Cho, a design director and photo art enthusiast with twenty years of creative experience. Inspired by her Korean childhood nickname, which means egg white canvas, the project became a space where imagination and storytelling could meet.',

        'We have covered many special events such as fireworks, fairs, parades, races, walks, award ceremonies, fashion shows, sporting events and memorial services.',

        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur vulputate vestibulum rhoncus, dolor eget viverra pretium, dolor tellus aliquet nunc, vitae ultrices erat elit eu lacus.',

        'Vivamus faucibus sed nibh egestas elementum. Mauris at bibendum.'
    ];

    /* ==========================================
        Quote
    ========================================== */

    quote = 'Your time is limited, so don’t waste it living someone else’s life. Don’t be trapped by dogma – which is living with the results.';

    quoteAuthor = 'John Mehedi';

    /* ==========================================
        Features
    ========================================== */

    featuresTitle = 'Let our investment management team';

    features: ArticleFeature[] = [

        {
            text: 'Lorem ipsum generators on the tend to repeat.'
        },
        {
            text: 'If you are going to use a passage.'
        },
        {
            text: 'Lorem ipsum generators on the tend to repeat.'
        },
        {
            text: 'Lorem ipsum generators on the tend to repeat.'
        }

    ];

    featureImage = '/assets/img/redesign/news/news.png';

    featureImageAlt = 'Article Feature';

    /* ==========================================
        Gallery
    ========================================== */

    gallery: GalleryImage[] = [

        {
            image: '/assets/img/redesign/news/news.png',
            alt: 'Gallery Image 1'
        },
        {
            image: '/assets/img/redesign/news/news.png',
            alt: 'Gallery Image 2'
        }

    ];

    /* ==========================================
        Conclusion
    ========================================== */

    conclusion = 'We have covered many special events such as fireworks, fairs, parades, races, walks, award ceremonies, fashion shows, sporting events and memorial services. Lorem ipsum dolor sit amet, consectetur adipiscing elit, vestibulum rhoncus, dolor eget viverra pretium, dolor elit aliquet nunc.';

    /* ==========================================
        Tags
    ========================================== */

    tags: ArticleTag[] = [

        {
            label: 'Business'
        },
        {
            label: 'Design'
        },
        {
            label: 'Apps'
        },
        {
            label: 'Data'
        }

    ];

    /* ==========================================
        Share
    ========================================== */

    shareFacebook = '#';

    shareLinkedin = '#';

    /* ==========================================
        TrackBy
    ========================================== */

    trackByIndex(index: number): number {

        return index;

    }

    trackByTag(index: number, tag: ArticleTag): string {

        return tag.label;

    }

}